import React, { useState, useEffect } from 'react';

const EncabezadosTabla = (p) => {
    const encabezados = p.encabezados ?? [];
    const headClass = p.headClass ?? "text-center text-white bg-black text-s nowrap";
    const funcion = p.funcion ?? null;
    useEffect(() => {

    }, []);

    return (
        <thead>
            <tr>
                {
                    encabezados.map((encabezado, index) => {
                        return <th key={index} scope='col' className={headClass + (funcion ? " pointer" : "")} onClick={() => { if (funcion) funcion() }}>{encabezado}</th>
                    })
                }
            </tr>
        </thead>
    )
}

export default EncabezadosTabla;